<template>
	<div class="relative">
		<!-- Intro Video -->
		<div class="w-full flex flex-col items-center">
			<div class="w-full px-4 2.5xl:px-0 max-w-8xl" :class="{ 'mt-20 md:mt-0': addBannerMargin }">
				<button
					@click="toggleVideo"
					class="w-full rounded-xl bg-ihh-pink text-ihh-midnight-gray px-3 pt-2 my-2 md:py-0 text-lg md:text-base active:scale-90 transition duration-200 focus:outline-none focus:ring-2 focus:ring-ihh-pink"
				>
					<div class="flex items-center justify-center">
						<img src="/images/play_icon.svg" class="w-12" />
						<!-- Mobile layout (flex-col) for small screens, row layout for md and up -->
						<div class="flex flex-col md:flex-row items-center justify-start">
							<!-- Close Video (when video is showing) -->
							<template v-if="showVideo">
								<div class="flex items-center justify-start">
									<div>Close Video</div>
									<img src="/images/chevron-left.svg" class="w-6" />
								</div>
							</template>
							<!-- Intro Video text (when video is not showing) -->
							<template v-else>
								<div class="md:flex md:items-center md:space-x-2">
									<div class="w-full md:w-auto text-start font-semibold leading-[0.75rem]">{{ 'Intro Video -' }}</div>
									<div class="flex items-center justify-start leading-[0.75rem]">
										<div>{{ 'Learn More About Us' }}</div>
										<img src="/images/chevron-right.svg" class="w-6" />
									</div>
								</div>
							</template>
						</div>
					</div>
				</button>
			</div>
			<transition
				enter-active-class="transition-all duration-500 ease-out"
				enter-from-class="opacity-0 max-h-0"
				enter-to-class="opacity-100 max-h-[600px]"
				leave-active-class="transition-all duration-500 ease-in"
				leave-from-class="opacity-100 max-h-[600px]"
				leave-to-class="opacity-0 max-h-0"
			>
				<div v-if="showVideo" class="w-full max-w-4xl overflow-hidden mt-4">
					<iframe
						src="https://player.vimeo.com/video/1026264453?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
						class="aspect-video rounded-xl w-full mx-auto bg-rum-100"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
						title="In His Hands Video"
					/>
				</div>
			</transition>
		</div>

		<!-- Spring Sale Banner -->
		<div v-if="isSaleActive" class="w-full flex items-center justify-center px-4">
			<img src="/images/marketing/spring-sale-banner-desktop.svg" class="hidden md2:block w-full max-w-8xl" />
			<img src="/images/marketing/3-2.svg" class="md2:hidden w-full max-w-8xl" />
		</div>

		<!-- birthing stuff -->
		<div class="flex w-full justify-center transition-all duration-500 ease-in-out">
			<div class="w-full xl:max-w-8xl grid grid-cols-2 md:grid-cols-6 gap-2 mx-4 my-4">
				<a
					v-for="(birthing, i) in birthings"
					:key="i"
					:href="birthing.link"
					class="relative overflow-hidden rounded-lg block"
					:class="{ 'col-span-2': !i, 'md:col-span-3': [0, 1].includes(i), 'md:col-span-2': ![0, 1].includes(i) }"
				>
					<img :src="birthing.image" class="rounded-lg w-full h-full min-h-52 max-h-52 md:min-h-96 md:max-h-fit object-center object-cover" />
					<div class="absolute inset-0 flex items-end justify-center bg-gradient-to-tr from-ihh-black/70 to-ihh-secondary-white/10">
						<div class="before-hover w-full">
							<div class="absolute inset-0 flex flex-col items-start justify-end text-white bottom-4 left-4 md:bottom-10 md:left-10 pr-4">
								<div class="text-2xl md:text-4xl tracking-wide font-semibold max-w-40 md:max-w-none">{{ birthing.title }}</div>
								<div class="text-xs md:text-base">{{ birthing.description }}</div>
								<div class="md:mt-4 rounded-xl">
									<div class="cursor-pointer group border-3 border-ihh-secondary-white rounded-xl overflow-hidden">
										<button class="text-xs md:text-sm group-hover:bg-ihh-secondary-white px-4 py-2 md:px-8 md:py-3 transition ease-in-out">
											Shop now
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
		<!-- birthing stuff -->

		<AboutService class="mt-10" />
		<!-- 3 Services that are offered by In His Hands -->
		<PopularProducts class="mt-10" />
		<!-- Items that are currently popular with people -->
		<FeaturedProducts class="mt-20" />
		<!-- Featured Items -->
		<PopularCategories />
		<!-- Large images and titles with "Shop Now" button -->
		<Midwife class="md:mt-10" />
		<!-- Random Items on display -->
		<!-- <RandomItems class="mt-16" /> -->
		<!-- Our Mission / Who We Are -->
		<MissionWWA />
	</div>
</template>
<script>
import Mango from '../../helpers/mango'
import Login from '../layout/login.vue'
import Logo from '../partials/logo.vue'
import AboutService from './ihh-items/about-service.vue'
import Midwife from './ihh-items/midwife.vue'
import MissionWWA from './ihh-items/mission-wwa.vue'
import FeaturedProducts from './ihh-items/featured-products.vue'
import PopularProducts from './ihh-items/popular-products.vue'
import RandomItems from './ihh-items/random-items.vue'
import PopularCategories from './ihh-items/popular-categories.vue'
import Button from '../partials/button.vue'

export default {
	components: { Login, Logo, Mango, AboutService, Midwife, PopularProducts, RandomItems, MissionWWA, FeaturedProducts, PopularCategories, Button },
	inject: ['store'],
	data() {
		return {
			showVideo: false,
			isTransitioning: false,
			currentTime: new Date(),
			timeInterval: null,
			birthings: [
				{
					title: 'Birth Kits',
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/original/image-manager/spring-homepage-edit.jpg?t=1740622288',
					description: 'Find your midwife’s custom birth kit',
					link: '/categories/birth-kits',
				},
				{
					title: 'Midwifery Equipment',
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/original/image-manager/midwife-supplies-1-.jpg?t=1732822690',
					description: 'Products for midwives, doulas and more',
					link: '/categories/midwifery-supplies',
				},
				{
					title: 'Water Birth',
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/original/image-manager/tubina-wild-090624-157-1-.jpeg?t=1738705799',
					description: 'Everything you need for a water birth',
					link: '/categories/water-birth',
				},
				{
					title: 'Herbal & Natural',
					image: '/images/natural-herbal-2-0129-2.jpg',
					description: 'Top quality natural products',
					link: '/categories/herbal-natural',
				},
				{
					title: 'For Mothers',
					image: '/images/birth-supplies0129.jpg',
					description: 'Pregnancy & postpartum essentials',
					link: '/categories/mom-baby',
				},
			],
		}
	},
	async mounted() {
		// Set document title to site name
		document.title = 'In His Hands Birth Supply'

		let r = await Mango.endpoints.authors.addresses.get()
		// console.log('endpoints response', r)

		// Set up a timer to update the currentTime every minute
		this.timeInterval = setInterval(() => {
			this.currentTime = new Date()
		}, 60000) // Update every minute (60000 ms)
	},
	methods: {
		toggleVideo() {
			this.showVideo = !this.showVideo
		},
	},

	computed: {
		isSaleActive() {
			// Define start and end dates in Central Time
			const startDate = new Date('2025-04-25T18:15:00-05:00') // 6:15 PM CT on 4/25/25
			const endDate = new Date('2025-04-28T23:59:59-05:00') // 11:59 PM CT on 4/28/25

			// Use the reactive currentTime property instead of creating a new Date
			// This will cause the computed property to re-evaluate when currentTime changes

			// Check if current date is between start and end dates
			return this.currentTime >= startDate && this.currentTime <= endDate
		},
		addBannerMargin() {
			if (this.isSaleActive) {
				if (this.store?.showSpringSaleBanner) {
					return true
				} else {
					return false
				}
			}
			if (this.store?.showBanner) {
				return true
			}
			return false
		},
	},

	// Clean up the interval when the component is destroyed
	beforeUnmount() {
		if (this.timeInterval) {
			clearInterval(this.timeInterval)
		}
	},
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 2s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
